module.exports = __webpack_public_path__ + "static/gallery34-0520cbcde3aea88a2c1e002f6c44fd47.png";